<template>
  <div>
  <b-container fluid class="page-header py-5 mb-5 text-center">
    <b-container class="py-5">
      <h1 class="display-3 text-white mb-3 animated slideInDown">Contact</h1>

      <!-- Breadcrumb -->
      <b-breadcrumb
        class="animated slideInDown justify-content-center"
        :items="breadcrumbItems"
        aria-label="breadcrumb"
      >
        <template #item="{ item }">
          <span :class="['breadcrumb-item', item.active ? 'active text-white' : 'text-white']">
            <router-link v-if="item.to" :to="item.to" class="text-white">{{ item.text }}</router-link>
            <span v-else>{{ item.text }}</span>
          </span>
        </template>
      </b-breadcrumb>
    </b-container>
  </b-container>
   <!-- Contact Info + Form -->
    <b-container class="py-5">
      <b-row>
        <!-- Contact Info Boxes -->
        <b-col md="6">
          <b-row>
            <b-col md="6" class="mb-4">
              <b-card class="text-center shadow-sm">
                <b-icon icon="telephone-fill" font-scale="2"></b-icon>
                <h5 class="mt-2">Phone</h5>
                <p>207-8767-452</p>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-4">
              <b-card class="text-center shadow-sm">
                <b-icon icon="whatsapp" font-scale="2"></b-icon>
                <h5 class="mt-2">Whatsapp</h5>
                <p>082-123-234-345</p>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-4">
              <b-card class="text-center shadow-sm">
                <b-icon icon="envelope-fill" font-scale="2"></b-icon>
                <h5 class="mt-2">Email</h5>
                <p>support@yoursite.com</p>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-4">
              <b-card class="text-center shadow-sm">
                <b-icon icon="geo-alt-fill" font-scale="2"></b-icon>
                <h5 class="mt-2">Our Office</h5>
                <p>2443 Oak Ridge Omaha, QA 45065</p>
              </b-card>
            </b-col>
          </b-row>
        </b-col>

        <!-- Contact Form with Validation -->
        <b-col md="6">
          <h3>Get In Touch</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
          </p>
          <b-form @submit.prevent="submitForm" novalidate>
            <b-form-group label="Name" label-for="name">
              <b-form-input
                id="name"
                v-model="form.name"
                :state="nameState"
                required
                placeholder="Enter your name"
              ></b-form-input>
              <b-form-invalid-feedback>Name is required.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                type="email"
                v-model="form.email"
                :state="emailState"
                required
                placeholder="Enter your email"
              ></b-form-input>
              <b-form-invalid-feedback>Valid email is required.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Subject" label-for="subject">
              <b-form-input
                id="subject"
                v-model="form.subject"
                :state="subjectState"
                required
                placeholder="Subject"
              ></b-form-input>
              <b-form-invalid-feedback>Subject is required.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Message" label-for="message">
              <b-form-textarea
                id="message"
                v-model="form.message"
                :state="messageState"
                rows="4"
                required
                placeholder="Your message"
              ></b-form-textarea>
              <b-form-invalid-feedback>Message is required.</b-form-invalid-feedback>
            </b-form-group>

            <b-button type="submit"  class="button-color">Send Now</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <!-- Map Section -->
    <b-container fluid class="map-section">
      <iframe
        src="https://www.google.com/maps?q=London+Eye&output=embed"
        width="100%"
        height="400"
        frameborder="0"
        style="border:0"
        allowfullscreen
      ></iframe>
    </b-container>
  </div>
</template>



<script>
export default {
  name: "ContactPage",
  data() {
    return {
      breadcrumbItems: [
        { text: 'Home', to: '/' },
        { text: 'Contact', to: '/contact' }
      ],
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  computed: {
    nameState() {
      return this.form.name.length > 0 ? true : null;
    },
    emailState() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.form.email) ? true : null;
    },
    subjectState() {
      return this.form.subject.length > 0 ? true : null;
    },
    messageState() {
      return this.form.message.length > 0 ? true : null;
    }
  },
  methods: {
    submitForm() {
      if (this.nameState && this.emailState && this.subjectState && this.messageState) {
        alert('Message sent successfully!');
        this.form = { name: '', email: '', subject: '', message: '' };
      } else {
        alert('Please fill out all fields correctly.');
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(rgba(22, 22, 22, 0.7), rgba(22, 22, 22, 0.7)),
  url('@/assets/carousel_1.jpg') center center no-repeat;
  background-size: cover;
  font-family: 'Poppins', sans-serif;
}
.breadcrumb-item {
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
}
.breadcrumb 
{ background-color: transparent !important; padding: 0; margin: 0; }

.breadcrumb-item .router-link-active,
.breadcrumb-item .router-link-exact-active,
.breadcrumb-item a {
  color: white !important;
  text-decoration: none;
}

h1 
{ 
  font-size: 3rem; /* Bigger size for About Us */ 
  font-family: 'Poppins',  sans-serif; 
  font-weight: bold;
}
.button-color{
  background-color: #990000 !important;
  color: #ffff;
}
.button-color:hover{
  background-color: #4D4D4D !important;
  color: #ffff;
}

</style>
